import { Edit3Icon } from "lucide-react";

import { FunctionComponent, useState } from "react";
import { DepositsService } from "../../../services/DepositService";

import { Modal, FormField, Alert } from "../../ui";

export interface EditCreditStatusModalProps {
    credit: any;
    onClose: () => void;
    onSuccess: () => void;
}

const STATUS_OPTIONS = ["PAID", "CANCELLED", "APPROVED"];

const EditCreditStatusModal: FunctionComponent<EditCreditStatusModalProps> = ({ credit, onClose, onSuccess }) => {

    const [status, setStatus]   = useState<string>(credit.status || "");
    const [loading, setLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [error, setError]     = useState<string>("");

    const handleSubmit = async () => {
        if (!status) return;

        setLoading(true);
        setError("");
        setSuccess(false);

        try {
            await DepositsService.updateCreditStatus(credit.id, status);
            setSuccess(true);
            setTimeout(() => { onSuccess(); onClose(); }, 1500);
        } catch (err: any) {
            setError(err?.message || "Erro ao atualizar status. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open
            onClose={onClose}
            icon={Edit3Icon}
            title="Editar Status"
            subtitle="altere o status do credito"
            footer={
                <button
                    className="btn-pill primary"
                    disabled={loading || !status}
                    onClick={handleSubmit}
                >
                    {loading ? <div className="loader" /> : "Salvar"}
                </button>
            }
        >
            {success && <Alert variant="success">Status atualizado com sucesso!</Alert>}
            {error   && <Alert variant="error">{error}</Alert>}

            <FormField label="Cliente" htmlFor="edit-client">
                <input id="edit-client" type="text" value={credit.user?.name || ""} disabled />
            </FormField>

            <FormField label="Valor" htmlFor="edit-value">
                <input id="edit-value" type="text" value={credit.value || ""} disabled />
            </FormField>

            <FormField label="Status" htmlFor="edit-status">
                <select
                    id="edit-status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={loading}
                >
                    <option value="">Selecione o status</option>
                    {STATUS_OPTIONS.map((opt) => (
                        <option key={opt} value={opt.toLowerCase()}>{opt}</option>
                    ))}
                </select>
            </FormField>
        </Modal>
    );
};

export default EditCreditStatusModal;
